import {actions} from './app.slice';
import axios from "axios";
import {baseUrl} from "../../api/network";
import {toast} from "react-toastify";
import toastOptions from "../../data/ToastOptions";
import store from "../store";

export const getPointsDataFn = (callback) => async (dispatch) => {
    const {tgUser} = store.getState().user;
    const headers = {
        'Content-Type': 'application/json',
    }
    axios.get(`${baseUrl}/points?user_tg_id=${tgUser?.id}`, {headers})
        .then(response => {
            dispatch(actions.setMainData(response?.data?.data));
            if (callback) {
                callback(response?.data?.data)
            }
        })
        .catch(() => {
            if (callback) {
                callback()
            }
            toast.error('Something went wrong. Please try again.', {...toastOptions, toastId: 28});
        })
};
